<soft-ds-card
  density="compact"
  [accent]="presentation().accent"
  [chevron]="isInteractive()"
  [class.is-running]="isRunning()"
  [style.--soft-report-card-running-ring]="accentVar()"
  (click)="activate()"
  (keydown.enter)="activate()"
  (keydown.space)="activate()"
>
  <soft-ds-card-header>
    <soft-ds-card-leading align="center">
      <span
        class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-base"
        [class]="presentation().iconClass"
      >
        <soft-icon [name]="presentation().icon" />
      </span>
    </soft-ds-card-leading>
    <soft-ds-card-title class="text-sm!">
      {{ report()?.activity?.name }} {{ report()?.activity?.title }}
    </soft-ds-card-title>
    <soft-ds-card-trailing align="center">
      @if (isRunning()) {
        <span
          class="inline-flex items-center gap-1.5 font-mono text-xs font-semibold tabular-nums"
          [style.color]="accentVar()"
        >
          {{ $safeNavigationMigration(report()?.from) | slice: 0 : 5 }} -
          <span class="inline-flex items-center gap-1 uppercase text-xs">
            <span
              class="h-2 w-2 rounded-full animate-pulse"
              [style.background]="accentVar()"
            ></span>
            läuft
          </span>
        </span>
      } @else {
        <span class="font-mono text-xs font-semibold tabular-nums text-primary">
          {{ $safeNavigationMigration(report()?.from) | slice: 0 : 5 }} - {{ $safeNavigationMigration(report()?.to) | slice: 0 : 5 }}
        </span>
      }
    </soft-ds-card-trailing>
  </soft-ds-card-header>

  <soft-ds-card-body class="gap-1 text-xs">
    <span class="inline-flex items-center gap-2">
      <soft-icon name="fa-regular fa-calendar" />
      {{ report().date | date: 'dd.MM.yyyy' }}
    </span>
    <span class="inline-flex items-center gap-2">
      <soft-icon name="fa-regular fa-user" />
      {{ report().employee?.id }} - {{ report().employee?.name }}
    </span>
    @if (report()?.object) {
      <span class="inline-flex items-center gap-2">
        <soft-icon name="fa-regular fa-car" />
        Objekt: {{ report()?.object?.number }} - {{ report()?.object?.name }}
      </span>
    }
  </soft-ds-card-body>
</soft-ds-card>
